import React, { useState, useEffect } from "react";
import {
  useUserEmail,
  useOrgPk,
} from "../../../../Layout/AppMain/LoginStatusContext";
import {
  Card,
  Table,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";
import { Link } from "react-router-dom";
import {
  CSO_CHECKOUT_TICKET,
  DELETE_ROLE,
  GET_ORG_PROFILE,
  GET_TICKET_PACKAGES,
  REGISTER_MAIL,
} from "../../../../queries";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
// import HorizontalScroller from "react-horizontal-scroll-container";
import SubmitReportCard from "../Components/Cards/SubmitReportCard";
import Pricing from "../../../Pricing";
import styles from "./index.module.scss";

const SettingOrgTab4 = ({ obj, refetch, userRole, toggle }) => {
  const userEmail = useUserEmail();
  const orgId = useOrgPk();
  const totalTicket = obj?.totalTicket ?? 0;

  let plan = "";
  try {
    plan = obj && obj.contract && obj.contract.plan;
  } catch (err) {
    plan = undefined;
  }
  const canEditMembers = obj.canEditMembers;

  //モーダル
  const [modal1, setModal1] = useState(false);
  const modalToggle1 = () => setModal1(!modal1);
  const [modal2, setModal2] = useState(false);
  const modalToggle2 = () => setModal2(!modal2);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const { data: ticketsData, loading: ticketLoading } =
    useQuery(GET_TICKET_PACKAGES);
  const ticketsPlan = ticketsData?.allTicket?.edges;

  //メンバー権限選択（ドロップダウン）
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownToggle = () => setDropdownOpen((prevState) => !prevState);
  const [dropdownValue, setDropdownValue] = useState("権限");

  // ミューテーション
  const [sendMail] = useMutation(REGISTER_MAIL);
  const [email, setEmail] = useState("");
  const [ability, setAbility] = useState("権限");
  const [deleteRole, { deletedRole }] = useMutation(DELETE_ROLE, {
    refetchQueries: [{ query: GET_ORG_PROFILE }],
  });

  //roleId State
  const [userId, setUserId] = useState("");

  //メンバー追加
  const addMember = async (e) => {
    try {
      if (ability === "権限") {
        alert("権限を選択してください");
      } else {
        modalToggle1();
        const result = await sendMail({
          variables: { email: email, orgId: obj.id, ability: ability },
        });
        alert(result.data.mail.result);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const [csoCheckoutTicket] = useMutation(CSO_CHECKOUT_TICKET);

  //メンバー削除
  const deleteRoleFunc = async (e) => {
    try {
      await deleteRole({
        variables: {
          roleId: userId,
        },
      });
      refetch();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleCheckout = async (ticketId) => {
    try {
      const res = await csoCheckoutTicket({
        variables: {
          ticketId: ticketId,
          orgId: obj.id,
        },
      });
      window.location.href = res.data.csoCheckoutTicket.url;
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <Card className="mb-2  org_contentarea">
        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              現在の契約プラン
            </h4>
          </div>
          {userRole === "can_edit" && (
            <Button className="mr-1 ema__btn__main">
              <Link
                to={{
                  pathname: `/dashboards/pricing`,
                }}
                style={{ color: "#fff", textDecoration: "none" }}
              >
                プランをアップグレード
              </Link>
            </Button>
          )}
        </div>

        <div className="plan_sec ema__flex ema__align_items_center">
          <div
            className="plan_left"
            style={{
              marginRight: "50px",
            }}
          >
            <dl>
              <dt>プラン</dt>
              {obj.contract === null ? (
                <dd>プランが登録されていません</dd>
              ) : (
                <dd>{plan.name}</dd>
              )}
            </dl>
            <dl>
              <dt>料金</dt>
              {obj.contract === null ? (
                <dd>プランが登録されていません</dd>
              ) : (
                <dd>
                  {plan.fee.toLocaleString("ja-JP", {
                    style: "currency",
                    currency: "JPY",
                  })}
                </dd>
              )}
            </dl>
            <dl
              style={{
                borderTop: "1px solid #e5e5e5",
                marginTop: "10px",
                paddingTop: "16px",
                maxWidth: "250px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <div>チケット枚数</div>
                <div>{totalTicket}枚</div>
              </div>
              <div>
                <button
                  className="ema__btn__main csv__button"
                  style={{
                    display: "flex",
                    padding: "0 22px",
                    justifyContent: "center",
                    height: "40.3px",
                    alignItems: "center",
                    borderRadius: "4px",
                    marginBottom: "8px",
                  }}
                  onClick={() => {
                    setPricingModalOpen(true);
                  }}
                >
                  追加
                </button>
              </div>
            </dl>
          </div>
          {userRole === "can_edit" && (
            <SubmitReportCard obj={obj} refetch={refetch} plan={plan} />
          )}
        </div>

        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              メンバー
            </h4>
          </div>
          {userRole === "can_edit" && (
            <Button className="mr-1 ema__btn__main" onClick={modalToggle1}>
              追加
            </Button>
          )}
        </div>
        {/* <HorizontalScroller className="scroller"> */}
        <Table borderless className="mb-0">
          {/* <thead> */}
          <tr>
            <th style={{ width: "50px" }}></th>
            <th style={{ width: "300px" }}>名前</th>
            <th>メールアドレス</th>
            <th>ステータス</th>
            {userRole === "can_edit" && <th>アクション</th>}
          </tr>
          {/* </thead> */}
          {/* <tbody> */}
          {obj.role.edges.map((array, index) => (
            <tr>
              <td
                scope="row"
                style={{ verticalAlign: "middle", width: "50px" }}
              >
                {index + 1}
              </td>

              <td style={{ display: "table-cell", verticalAlign: "middle" }}>
                {array.node.user.additionalInfo === null ? (
                  <td>ユーザー名が設定されていません</td>
                ) : (
                  <td>{array.node.user.additionalInfo.username}</td>
                )}
              </td>

              <td>{array.node.user.email}</td>
              <td>{array.node.ability}</td>
              <td>
                {userRole === "can_edit" && (
                  <div>
                    {canEditMembers < 2 ? (
                      <div>
                        {array.node.user.email === userEmail ? (
                          <Button
                            disabled
                            onClick={(e) => {
                              modalToggle2();
                              setUserId(e.target.value);
                            }}
                            className="mr-1 main_button"
                            style={{ background: "#E36B6B" }}
                            value={array.node.id}
                          >
                            削除
                          </Button>
                        ) : (
                          <Button
                            onClick={(e) => {
                              modalToggle2();
                              setUserId(e.target.value);
                            }}
                            className="mr-1 main_button"
                            style={{ background: "#E36B6B" }}
                            value={array.node.id}
                          >
                            削除
                          </Button>
                        )}
                      </div>
                    ) : (
                      <Button
                        onClick={(e) => {
                          modalToggle2();
                          setUserId(e.target.value);
                        }}
                        className="mr-1 main_button"
                        style={{ background: "#E36B6B" }}
                        value={array.node.id}
                      >
                        削除
                      </Button>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
          {/* </tbody> */}
        </Table>
        {/* </HorizontalScroller> */}
      </Card>

      <Modal isOpen={modal1} toggle={modalToggle1}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold">メールアドレス</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextareaAutosize
              className="form-control mr-2"
              maxRows={3}
              placeholder="xxxxx@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Dropdown isOpen={dropdownOpen} toggle={dropdownToggle}>
              <DropdownToggle
                caret
                style={{
                  background: "#fff",
                  color: "#495057",
                  borderColor: "#ced4da",
                }}
              >
                {dropdownValue}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setAbility("can_edit");
                    setDropdownValue("編集");
                  }}
                >
                  編集
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setAbility("only_view");
                    setDropdownValue("閲覧");
                  }}
                >
                  閲覧
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button onClick={addMember} className="main_button">
            送信
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={modalToggle2}>
        <ModalBody className="mt-4 ml-3 mr-3 mb-2">
          <p className="bold">メンバーを削除します。よろしいですか？</p>
          <Button
            onClick={() => {
              deleteRoleFunc();
              modalToggle2();
            }}
            className="main_button"
            style={{ background: "#E36B6B" }}
          >
            削除
          </Button>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={pricingModalOpen}
        toggle={() => setPricingModalOpen(!pricingModalOpen)}
        backdropClassName="reverted-backdrop"
        size="sm"
        contentClassName={styles["modal-content"]}
        className={styles["modal-dialog"]}
      >
        <ModalBody>
          <div
            style={{
              marginTop: "70px",
              marginBottom: "70px",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            チケット購入
          </div>
          <div
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            {ticketsPlan?.map((ticket, idx) => {
              return (
                <div
                  key={ticket?.node?.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #E0E0E0",
                    borderTop: "1px solid #E0E0E0",
                    marginBottom: idx === ticketsPlan.length - 1 ? "70px" : "0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "20px",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "58px",
                      }}
                    >
                      {ticket?.node?.amount}枚
                    </div>
                    <div>
                      ¥
                      {String(ticket?.node?.price).toLocaleString("ja-JP", {
                        style: "currency",
                        currency: "JPY",
                      })}
                    </div>
                  </div>
                  <button
                    style={{
                      backgroundColor: "#44CAE1",
                      color: "white",
                      borderRadius: "4px",
                      border: "none",
                      padding: "12px 24px",
                    }}
                    onClick={() => handleCheckout(ticket?.node?.id)}
                  >
                    購入
                  </button>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SettingOrgTab4;
